import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const FoldersList = styled.div`
  background-color: green;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background-color: #FFFFFF78;
  border: 1px solid #FFFFFF
`